import { Box, Typography, Button, Modal } from "@mui/material";
import React, { useState } from "react";
import globalStyles from "../global";
import Footer from "../components/HomeComponent/Footer";
import { useTranslation } from "react-i18next";
import SupportSystem from "../../src/pages/supportSystem";
import FranchiseForm from '../components/FranchiseForm';

const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

// Use hardcoded font sizes directly in sx for each element
const FranchiseModel = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box>
      <Box sx={styles.box1}>
        <Box sx={styles.centerContent}>
          {/* Title and Subtitle in one box for matching width and spacing */}
          <Box sx={styles.bannerTextWrapper}>
            <Typography variant="title_banner" sx={styles.titleBanner}>
              {t("franchiseModel.whyInvestTitle")}
            </Typography>
            <Typography variant="subtitle_banner" sx={styles.subtitleBanner}>
              {t("franchiseModel.whyInvestDescription")}
            </Typography>
          </Box>
          {/* Button */}
          <Button
            variant="contained"
            color="success"
            sx={{
              fontWeight: 600,
              fontSize: {
                sm: "18px",
                xs: "14px"
              },
              px: 5,
              py: 1.5,
              borderRadius: 2,
              background: globalStyles.colors.successGreen || "#7ED957",
              boxShadow: "none",
              textTransform: "none",
              mt: 2,
              "&:hover": {
                background: globalStyles.colors.successGreen || "#7ED957"
              }
            }}
            onClick={handleOpen}
          >
            {t("franchiseModel.applyButton", "Apply for Franchise")}
          </Button>
          <Modal open={open} onClose={handleClose}>
            <Box sx={styles.modalBox}>
              <FranchiseForm onClose={handleClose} />
            </Box>
          </Modal>
        </Box>
      </Box>
      <SupportSystem />
      <Footer />
    </Box>
  );
};

const styles = {
  box1: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: globalStyles.colors.army_green,
    backgroundImage: `url(${imageBaseUrl}ContactBanner.svg)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: { xs: "280px", sm: "440px", md: "500px" }, // updated
    height: { xs: "280px", sm: "440px", md: "500px" },    // updated
    position: "relative",
  },
  centerContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
  },
  bannerTextWrapper: {
    width: { xs: "100%", md: "64%" , sm: "85%"}, // Ensures both lines have same width, adjust as needed
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: { xs: 2, md: 3 },
  },
  titleBanner: {
    color: "#FFF",
    fontFamily: '"AllRoundGothicBold", AllRoundGothic-Bold, sans-serif',
    fontWeight: 400,
    fontSize: { xs: "20px", sm: "26px", md: "45px" },
    lineHeight: { xs: "26px", sm: "32px", md: "55px" },
    letterSpacing: "1%",
    textTransform: "uppercase",
    textAlign: "center",
    width: "100%",
    marginBottom: { xs: 1, md: 2 }, // spacing between title and subtitle
  },
  subtitleBanner: {
    color: "#FFF",
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 400,
    fontSize: { xs: "12px", sm: "16px", md: "20px" },
    lineHeight: { xs: "16px", sm: "22px", md: "30px" },
    letterSpacing: "0%",
    textAlign: "center",
    width: "100%",
    marginBottom: 0,
  },
  modalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: { xs: "90vw", md: 700 },
  }
};

export default FranchiseModel;